{"frontendApi": "https://palchiki.com/api/palchiki-web", "backendApi": "http://localhost:8088/palchiki-web" }
